import { DATE_FORMAT } from '../constants/general';

const monthsMap = [
  ['Jan', '01'],
  ['Feb', '02'],
  ['Mar', '03'],
  ['Apr', '04'],
  ['May', '05'],
  ['Jun', '06'],
  ['Jul', '07'],
  ['Aug', '08'],
  ['Sep', '09'],
  ['Oct', '10'],
  ['Nov', '11'],
  ['Dec', '12'],
];

const monthsMapFull = [
  ['January', '01'],
  ['February', '02'],
  ['March', '03'],
  ['April', '04'],
  ['May', '05'],
  ['June', '06'],
  ['July', '07'],
  ['August', '08'],
  ['September', '09'],
  ['October', '10'],
  ['November', '11'],
  ['December', '12'],
];

export const refactoredTimeAndDate = (dateStr:string, forComponent:string | undefined | null, format: string, withHoursAndMin?: boolean) => {
  const date = new Date(new Date(dateStr).toString());
  const month = format === DATE_FORMAT.LETTERS ? monthsMap[date.getMonth()][0] : format === DATE_FORMAT.LETTERS_FULL ? monthsMapFull[date.getMonth()][0] : monthsMap[date.getMonth()][1];

  const handleAmPm = (num: number) => {
    if (num > DATE_FORMAT.SELECT_AM_OR_PM) {
      const res = num - DATE_FORMAT.SELECT_AM_OR_PM;
      if (res < DATE_FORMAT.NEED_ZERO_STRING_BEFORE) {
        return `0${res}`;
      } return `${res}`;
    } if (num < DATE_FORMAT.NEED_ZERO_STRING_BEFORE) {
      return `0${num}`;
    } return `${num}`;
  };

  const minutesRefactor = (num: number) => {
    if (num < DATE_FORMAT.NEED_ZERO_STRING_BEFORE) {
      return `0${num}`;
    } return `${num}`;
  };

  if (format === DATE_FORMAT.NUMBERS) {
    const dayInNumbers = date.getDate() < DATE_FORMAT.NEED_ZERO_STRING_BEFORE ? `0${date.getDate()}` : date.getDate().toString();
    const monthInNumbers = date.getMonth() + 1 < DATE_FORMAT.NEED_ZERO_STRING_BEFORE ? `0${date.getMonth() + 1}` : (date.getMonth() + 1).toString();
    const yearInNumbers = date.getFullYear().toString();
    if (withHoursAndMin) {
      const hoursAndMin = `${date.getHours() + 1 < DATE_FORMAT.NEED_ZERO_STRING_BEFORE ? `0${date.getHours()}` : date.getHours()}:${date.getMinutes()}`;
      return `${monthInNumbers}.${dayInNumbers}.${yearInNumbers} ${hoursAndMin}`;
    }
    return `${monthInNumbers}/${dayInNumbers}/${yearInNumbers}`;
  }
  if (forComponent === 'dashboard') {
    return `${month.toString()} ${date.getDate()}, ${handleAmPm(date.getHours())}:${minutesRefactor(date.getMinutes())}`;
  }
  if (forComponent === 'CategorizeExpenses') {
    return `${month.toString()} ${date.getDate()}, ${date.getFullYear()} ${handleAmPm(date.getHours())}:${minutesRefactor(date.getMinutes())}`;
  }
  if (forComponent === 'PlaidTransferConfirmation' || forComponent === 'InvoiceCreation') {
    return `${date.getDate()} ${month.toString()}, ${date.getFullYear()}`;
  }
  if (forComponent === 'CardTrackerStep') {
    return `${month.toString()} ${date.getDate()} `;
  }
  if (forComponent === 'ACH-out') {
    return `${month.toString()} ${date.getDate()}, ${date.getFullYear()} - ${date.getHours()}:${minutesRefactor(date.getMinutes())}`;
  }
  if (forComponent === 'SEND-MONEY') {
    return `${date.getDate()} ${month.toString()} ${date.getFullYear()} - ${date.getHours()}:${minutesRefactor(date.getMinutes())}`;
  }
  return `${month.toString()} ${date.getDate()}, ${date.getFullYear()}${forComponent === 'details' ? ` • ${handleAmPm(date.getHours())}:${minutesRefactor(date.getMinutes())} ${date.getHours() > DATE_FORMAT.SELECT_AM_OR_PM ? DATE_FORMAT.PM : DATE_FORMAT.AM}` : ''}`;
};
